"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _stylitas = require("@creditas/stylitas");

var _propTypes = require("prop-types");

var _components = require("./components");

var _core = require("@emotion/core");

const CheckboxInput = _stylitas.styled.input`
  ${_components.checkboxInput};
`;
const CheckboxLabel = _stylitas.styled.label`
  ${({
  boxed
}) => boxed ? _components.checkboxBoxedLabel : _components.checkboxLabel}
`;
const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  children: _propTypes.node.isRequired,
  id: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  checked: _propTypes.bool,
  defaultChecked: _propTypes.bool,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  value: _propTypes.any,
  boxed: _propTypes.bool,
  fullWidth: _propTypes.bool,
  disabled: _propTypes.bool
} : {};
const defaultProps = {
  component: 'div',
  onBlur: () => null,
  boxed: false,
  fullWidth: false,
  disabled: false
};

const Checkbox = /*#__PURE__*/_react.default.forwardRef(function (props, withRef) {
  const {
    children,
    id,
    name,
    checked,
    disabled,
    defaultChecked,
    onChange,
    onBlur,
    component: Root,
    className,
    value,
    boxed,
    fullWidth,
    ...other
  } = props;
  return (0, _core.jsx)(Root, (0, _extends2.default)({
    className: className
  }, other), (0, _core.jsx)(CheckboxInput, {
    id: id,
    name: name,
    onChange: onChange,
    onBlur: onBlur,
    type: "checkbox",
    defaultChecked: defaultChecked,
    checked: checked,
    disabled: disabled,
    value: value,
    boxed: boxed,
    ref: withRef
  }), (0, _core.jsx)(CheckboxLabel, {
    htmlFor: id,
    boxed: boxed,
    fullWidth: fullWidth
  }, children));
});

exports.Checkbox = Checkbox;
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = propTypes : void 0;
Checkbox.defaultProps = defaultProps;